import { connect } from "vuex-connect";
import { MyWallsSettings } from "../../../components";

export default connect({
  stateToProps: {
    isBusy: state => state.common.isBusy
  },
  actionsToProps: {
    uploadDraftWallThumbnailImage: "myWalls/uploadDraftWallThumbnailImage",
    saveSettingsChanges: "myWalls/saveSettingsChanges"
  },
  mutationsToProps: {
    setIsBusy: "common/setIsBusy"
  }
})(MyWallsSettings.name, MyWallsSettings);
